module.exports = __webpack_public_path__ + "static/media/goiania-go.54c66e27.jpg";